import authorizationService from "@/services/authorization.service";
import sharedService from "@/services/shared.service";

const state = {
    isUserLoading: false,
    selectedUser: null,
    userRoles: Array
};

const getters = {
    isUserLoading: (state) => state.isUserLoading,
    selectedUser: (state) => state.selectedUser,
    userRoles: (state) => state.userRoles,
    isSelectedUserAdmin: (state) => state.selectedUser && (state.selectedUser.role === 'ADMIN' || state.selectedUser.role === 'SUPER_ADMIN'),
    isSelectedUserActive: (state) => state.selectedUser && state.selectedUser.active
};

const actions = {
    fetchUserById({commit}, id) {
        commit('setIsUserLoading', true);
        authorizationService.getUserById(id)
            .then(({data}) => {
                commit('setSelectedUser', data);
                commit('setIsUserLoading', false);
            });
    },
    fetchUserRoles({commit}) {
        sharedService.fetchUserRoles()
            .then(({data}) => {
                commit("setUserRoles", data);
            })
    }
};

const mutations = {
    setIsUserLoading: (state, isUserLoading) => (state.isUserLoading = isUserLoading),
    setSelectedUser: (state, selectedUser) => (state.selectedUser = selectedUser),
    setUserRoles: (state, roles) => (state.userRoles = roles)
};

export default {
    state,
    getters,
    actions,
    mutations
};
